export const CoreTheme = {
  primaryColor: '#ff002d',
  primaryFont: "Mapfre Text",
  primaryFontTitles: "Mapfre Display",

  secondaryColor: '#fff',
  fontSizeXSmall: '8px',
  fontSizeSmall: '10px',
  fontSizeMedium: '12px',
  fontSizeMediumLarge: '14px',
  fontSizeLarge: '16px',
  fontSizeXLarge: '18px',
  fontSizeXXLarge: '22px',
  fontSizeXXXLarge: '24px',
  lightGrease: '#f5f5f5',
  grease: '#8d8d8d',

  urlLogoHorizontal: 'url("assets/mapfre-full-white.svg")',
  urlLogoVertical: 'url("assets/logo-mapfre-vertical.svg")',
  urlLogin: 'url("assets/login-bg.jpg")',
  urlLoginLogo: 'url("assets/login-logo.jpg")',
  loginHeightLogo: '66px',
  headerTextColor: '#fff',
  headerWidthLogo: '150px',

  error: '#df0027',
  success: '#3ad860',
  black: '#000000',
  warning: '#ffd840',
  info: '#8d8d8d',


  baseBorderRadius: '2px',
  'rusty-red': '#a0001c',
  'greyish-brown': '#666666',
  'brown-grey': '#8d8d8d',
  'white': '#fff',
  'blue': '#349ea0',
  'light-grey': '#b3b3b3',
  'extra-light-grey': '#d9d9d9',
  'turquoise': '#4bced1',
  'dark-grey': '#404040',

  'dark-blue': '#063f3f'
};
